import {css} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {NODE_SECTION_ROW_STYLES} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';
import {RowHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';
import {SimpleRowData} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/SimpleBenchlingNodeTypes';

type SimpleBenchlingNodeSectionRowProps = SimpleRowData & {
  rowHandleRenderer?: (props: RowHandleProps<SimpleRowData>) => JSX.Element | null;
};

function PrimaryColumn(props: {primaryColumn: string}): JSX.Element {
  return (
    <div
      className={css(NODE_SECTION_ROW_STYLES.rowPrimaryColumn)}
      {...getTestProps({
        component: 'SimpleBenchlingNodeSectionRow',
        element: 'primaryColumn',
      })}
    >
      {props.primaryColumn}
    </div>
  );
}

function SecondaryColumn(props: {secondaryColumn: string}): JSX.Element {
  return (
    <div
      className={css(NODE_SECTION_ROW_STYLES.rowSecondaryColumn)}
      {...getTestProps({
        component: 'SimpleBenchlingNodeSectionRow',
        element: 'secondaryColumn',
      })}
    >
      {props.secondaryColumn}
    </div>
  );
}

/**
 * The default section row renderer for the SimpleBenchlingNode.
 *
 * This is out-of-the-box functionality to render rows in each section.
 * See JellyfishNode.stories.tsx for an example of a custom row renderer.
 */
export function SimpleBenchlingNodeSectionRow({
  rowHandleRenderer,
  ...rowData
}: SimpleBenchlingNodeSectionRowProps): JSX.Element {
  return (
    <div
      className={css(NODE_SECTION_ROW_STYLES.sectionRow)}
      {...getTestProps({
        component: 'SimpleBenchlingNodeSectionRow',
        element: 'root',
        key: rowData.primaryColumn,
      })}
    >
      <PrimaryColumn primaryColumn={rowData.primaryColumn} />
      {rowData.secondaryColumn && <SecondaryColumn secondaryColumn={rowData.secondaryColumn} />}
      {rowHandleRenderer && (
        <>
          {rowHandleRenderer({
            rowData,
            handleType: 'target',
          })}
          {rowHandleRenderer({
            rowData,
            handleType: 'source',
          })}
        </>
      )}
    </div>
  );
}
